import type { Permission } from './permissions.env.ts'

export function hasPermission(userPermissions: Permission[], permissions: Permission[]) {
	if (!userPermissions || !permissions || permissions.length === 0) return false
	const isAnyPermissions = permissions.includes('any' as Permission)
	if (isAnyPermissions) return true

	const hasWildcard = userPermissions.includes('*' as Permission)
	if (hasWildcard) return true

	return permissions.every(permission => userPermissions.includes(permission))
}

/** Хотя бы одно из перечисленных прав (для пунктов меню и страниц с частичным доступом). */
export function hasAnyPermission(userPermissions: Permission[], permissions: Permission[]) {
	if (!userPermissions || !permissions || permissions.length === 0) return false
	const isAnyPermissions = permissions.includes('any' as Permission)
	if (isAnyPermissions) return true

	const hasWildcard = userPermissions.includes('*' as Permission)
	if (hasWildcard) return true

	return permissions.some(permission => userPermissions.includes(permission))
}
